import styled from 'styled-components';

export const SwtchBtn = styled.div`
  display: inline-flex;
`;

export const InputBtn = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;

  &:checked + label > span {
    left: 24px;
    background: #fff;
    top: 4px;
    width: 24px;
    height: 24px;
  }
  &:checked + label {
    border-color: rgb(0, 140, 255);
  }
`;

export const Label = styled.label`
  background: ${props =>
    props.isEnabled ? props.defaultEnabledColor : props.defaultDisabledColor};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 52px;
  height: 32px;
  border-radius: 100px;
  position: relative;
  transition: background-color 0.2s;
  &:active > span {
    width: 40px;
  }
`;

export const Toggle = styled.span`
  content: '';
  border: none;
  position: absolute;
  top: 3px;
  left: 4px;
  width: 25px;
  height: 25px;
  border-radius: 45px;
  transition: 0.2s;
  background: #fff;
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
`;
